import axiosHttp from "services/axiosHttp";

// Payment Service Functions
export const paymentService = {
  // Create payment
  createPayment: async (data) => {
    const response = await axiosHttp.post("/pmo/payment", data);
    return response.data;
  },

  // Get payment list with optional params
  getPaymentList: async (params = {}) => {
    const response = await axiosHttp.get("/pmo/payment", { params });
    return response.data;
  },

  // Get single payment by ID
  getPayment: async (id) => {
    const response = await axiosHttp.get(`/pmo/payment/${id}`);
    return response.data;
  },

  // Update payment
  updatePayment: async (id, data) => {
    const response = await axiosHttp.put(`/pmo/payment/${id}`, data);
    return response.data;
  },

  // Delete payment
  deletePayment: async (id) => {
    const response = await axiosHttp.delete(`/pmo/payment/${id}`);
    return response.data;
  },
};

